module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b8O7v"))).then(() => parcelRequire('d0iPb'));